"use client";
import { useEffect, useRef } from "react";
import { ScaleLoader } from "react-spinners";
function LazyLoading({
  loading,
  totalRecords,
  isLastPage,
  onPagination,
  data,
}) {
  const loader_ref = useRef();
  const callback = (entries) => {
    entries.forEach((entry) => {
      console.log(
        "in lazy",
        entry.isIntersecting,
        !loading,
        isLastPage,
        totalRecords
      );

      if (entry.isIntersecting && !loading && isLastPage && totalRecords > 0) {
        onPagination();
      }
    });
  };

  const options = {
    threshold: 1.0,
    // rootMargin: "10px",
    // root: document.querySelector("#root")
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callback, options);
    if (loader_ref.current) {
      observer.observe(loader_ref.current);
    }

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line
  }, [loading, data, totalRecords]);

  return (
    <>
      {loading && (
        <div
          className="mt2 mb2"
          style={{
            height: "5rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div>
            <ScaleLoader color={"#2f2d51"} />
          </div>
        </div>
      )}
      <div className="loaderSpace" ref={(ref) => (loader_ref.current = ref)} />
    </>
  );
}

export default LazyLoading;
